import { FC } from "react";

import { copy } from "shared/assets";
import { Button, Loader } from "shared/components";

const { venueBlock: venueBlockCopy } = copy;

interface LinkVenueButtonProps {
  label?: string;
  handleSubmit: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  dataTestId?: string;
}

export const LinkVenueButton: FC<LinkVenueButtonProps> = ({
  label,
  handleSubmit,
  isDisabled,
  isLoading,
  dataTestId,
}) => {
  return (
    <Button
      size="l"
      isFullWidth
      onClick={handleSubmit}
      disabled={isDisabled}
      data-testid={dataTestId}
    >
      <span>{label || venueBlockCopy.buttons.linkVenue}</span>
      {isLoading && <Loader size="s" />}
    </Button>
  );
};
